module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_6005.1fb2f359.png";